export default __webpack_public_path__ + "fonts/iconfont.c70426faf56692ff67f65e8f576f7d96.eot";